// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__ZrDcz","modalFooterButton":"ModalNotes_modalFooterButton__2MrMG"};